const dateWithinLastNDays = (date: string, numberOfDays: number) => {
  const givenDate = new Date(date);
  const currentDate = new Date();
  const nDaysAgoDateNumber = currentDate.setDate(currentDate.getDate() - numberOfDays);
  const nDaysAgoDate = new Date(nDaysAgoDateNumber);
  return givenDate > nDaysAgoDate;
};

export default dateWithinLastNDays;
